export const SELECT_IBAN_FOOTER_ACTION_PROPS = {
  dataTestId: 'select-iban-footer-action',
  variant: 'ACTION_BUTTONS',
};
export const SELECT_IBAN_FOOTER_ACTION_LINK_PROPS = {
  dataTestId: 'select-iban-footer-action-link',
  type: 'SECONDARY',
  size: 'LARGE',
  disabled: false,
};
export const SELECT_IBAN_FOOTER_ACTION_BUTTON_PROPS = {
  dataTestId: 'select-iban-footer-action-button',
  type: 'PRIMARY',
  size: 'LARGE',
};
export const FINANCIAL_DATA_PROPS = {
  showTooltip: false,
};
